// removed by extract-text-webpack-plugin
module.exports = {"headings":"src-components-modules-HeadingBlock-style----general-module---headings---28NdX breakPointM-width-auto display-flex flexDirection-column height-100 width-100"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/HeadingBlock/style/general.module.css
// module id = 1468
// module chunks = 168707334958949